import { renderImage } from "../../utils/helper";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { Card, CardFooter } from "../card/card";
import ConfirmationDlg from "../ConfirmationDlg";

function ImageViewer({ src, staticImage, size = "lg", title = false, disableBox = false }) {
  const [imgLoading, setImgLoading] = useState(true);
  const [imageExist, setImageExist] = useState(true);
  const [show, setShow] = useState(false);
  const [source, setSource] = useState();

  useEffect(() => {
    if (src) {
      setImageExist(true);
      setSource(src);
    }
  }, [src]);
  return (
    <Card className="w-100 p-1">
      <ConfirmationDlg
        size={size}
        type={"alert"}
        hideCancelBtn={true}
        open={show}
        onClose={() => setShow(false)}
      >
        <img
          src={
            staticImage
              ? staticImage
              : renderImage(`machine/attachment/${source}`)
          }
          style={{ width: "100%" }}
          alt=""
        />
      </ConfirmationDlg>
      {imgLoading && (
        <div className="d-flex justify-content-center">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
      {!imageExist && (
        <div
          style={{
            textAlign: "center",
            background: "#2b3a45",
            aspectRatio: "1/1",
            padding: "10px",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <i className="fa fa-image fa-3x"></i>
        </div>
      )}
      {imageExist && (
        <img
          src={`${
            staticImage
              ? staticImage
              : renderImage(
                  `machine/attachment/${source}?time=${new Date().getTime()}`
                )
          }`}
          onClick={() => setShow(true)}
          onLoad={() => {
            setImgLoading(false);
            setImageExist(true);
          }}
          onError={() => {
            setImageExist(false);
            setImgLoading(false);
          }}
          style={{
            width: "100%",
            aspectRatio: disableBox ? "auto" : "1/1",
            cursor: "pointer",
            objectFit: "cover",
          }}
          alt=""
        />
      )}
      {title ? (
        <CardFooter className={"text-center"}>{title}</CardFooter>
      ) : null}
    </Card>
  );
}

export default ImageViewer;
